var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingAssets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_118_481",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 416,
    height: 80
  }, /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 80,
    fill: "#D9D9D9",
    id: "svg_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    mask: "url(#mask0_118_481)",
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0BB3F0",
    d: "m98.76323,18.5575c30.94004,-2.0924 61.73926,-3.9318 92.90024,-4.2478c35.09574,-0.3558 70.74822,-0.668 105.69244,1.424c17.29182,1.0352 34.52491,2.7538 51.54188,4.8029c14.88868,1.7926 30.49853,3.8073 44.04938,8.0128c5.20798,1.6164 11.18412,3.8426 12.62648,7.4577c2.40079,6.0178 -5.77882,11.7171 -13.53794,14.9155c-11.56233,4.7662 -26.3406,7.101 -39.82568,9.0989c-24.11834,3.5734 -48.82395,5.9618 -73.52487,7.6267c-32.73371,2.2063 -65.76928,3.2349 -98.69679,3.7651c-41.31267,0.6652 -85.48514,1.7461 -126.26762,-3.1858c-12.75462,-1.5425 -51.81921,-6.4249 -43.59356,-19.7908c6.78896,-11.0314 34.96504,-15.6588 49.59648,-18.2944c32.28115,-5.8148 70.78534,-8.8031 103.91252,-11.44c71.54457,-5.695 143.23009,-8.2531 215.3173,-9.7023",
    strokeWidth: 8,
    strokeLinecap: "round",
    id: "svg_3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingAssets);
export default __webpack_public_path__ + "static/media/marketing_assets.2edd48995d9a3d6eb903c5b48eb4e3bc.svg";
export { ForwardRef as ReactComponent };